'use client'

import { BedCoolingLP } from 'pageCores/bed-cooling-system'
import { useMetricRegion } from 'stores/settings'

const BedCoolingSystemContent = () => {
	const metricRegion = useMetricRegion()
	return <BedCoolingLP metricRegion={metricRegion} />
}

export { BedCoolingSystemContent }
